var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.890137,
    width: 30,
    height: 30,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_2664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1337 21.8903H8.23125V12.5434H11.1337V21.8903ZM9.68094 11.2684C8.75281 11.2684 8 10.4997 8 9.57156C8 9.12575 8.1771 8.6982 8.49234 8.38296C8.80757 8.06772 9.23513 7.89062 9.68094 7.89062C10.1267 7.89062 10.5543 8.06772 10.8695 8.38296C11.1848 8.6982 11.3619 9.12575 11.3619 9.57156C11.3619 10.4997 10.6088 11.2684 9.68094 11.2684ZM21.9969 21.8903H19.1006V17.3403C19.1006 16.2559 19.0787 14.8653 17.5916 14.8653C16.0825 14.8653 15.8513 16.0434 15.8513 17.2622V21.8903H12.9519V12.5434H15.7356V13.8184H15.7762C16.1637 13.0841 17.1103 12.3091 18.5225 12.3091C21.46 12.3091 22 14.2434 22 16.7559V21.8903H21.9969Z",
    fill: "#25282B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_2664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7.89014)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF6);
export default __webpack_public_path__ + "static/media/f6.76559663684713ae5b28b2f8f21162a9.svg";
export { ForwardRef as ReactComponent };